import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
`;

export const UserManagementSection = styled.div`
  padding: ${({ theme }) => theme.spaces.xl}rem;
  border-radius: 1rem;
  background: ${({ theme }) =>
    theme.colors.backgroundLila}; /* CAMBIO: Color lila ROIS */
  margin-bottom: ${({ theme }) => theme.spaces.xl}rem;
  width: 100%;
`;
